export default {
  _name: 'light',
  _appearance: 'light',

  background: '#F9FAFC',
  border: '#DDE4E9',
  overlay: '#FFFFFF',
  content: '#212B36',
  contentSecondary: '#637381',

  surface: '#FFFFFF',
  surfaceContent: '#212B36',
  surfaceContentSecondary: '#637381',
  surfaceIcon: '#8FA4B5',
  surfaceUnder: '#F1F3F7',
  surfaceOpened: '#ABBECF',
  surfaceSelected: '#F9FAFC',
  surfaceHighlight: '#F9FAFC',
  surfacePressed: '#F9FAFC',
  surfaceInteractive: '#FFFFFF',

  feedbackSurface: '#F9FAFC',
  feedbackSurfaceContent: '#212B36',
  feedbackSurfaceContentSecondary: '#637381',

  warning: '#F5A623',
  warningSurface: '#FFF1DA',
  warningSurfaceContent: '#C7871E',

  info: '#08BEE5',
  infoSurface: '#EBFAFD',
  infoSurfaceContent: '#0792AF',

  help: '#7C80F2',
  helpContent: '#FFFFFF',
  helpSurface: '#FFFFFF',
  helpSurfaceContent: '#212B36',

  negative: '#FF6969',
  negativeContent: '#FFFFFF',
  negativeSurface: '#FFE8E8',
  negativeSurfaceContent: '#CA4141',

  positive: '#2CC68F',
  positiveContent: '#FFFFFF',
  positiveSurface: '#D8FFF1',
  positiveSurfaceContent: '#1B8962',

  badge: '#EBFAFD',
  badgeContent: '#212B36',
  badgePressed: '#F9FAFC',

  tagIdentifier: '#EDE6FF',
  tagIdentifierContent: '#4D22DF',

  tagNew: '#D8FFF1',
  tagNewContent: '#2CC68F',

  tagIndicator: '#EBFAFD',
  tagIndicatorContent: '#08BEE5',

  tagActivity: '#08BEE5',
  tagActivityContent: '#FFFFFF',

  hint: '#8FA4B5',
  link: '#3E7BF6',
  focus: '#3E7BF6',
  selected: '#08BEE5',
  selectedContent: '#FFFFFF',
  selectedDisabled: '#C4CDD5',

  disabled: '#F1F3F7',
  disabledContent: '#637381',
  disabledIcon: '#8FA4B5',

  control: '#F9FAFC',
  controlBorder: '#DDE4E9',
  controlBorderPressed: '#ABBECF',
  controlDisabled: '#F1F3F7',
  controlSurface: '#F9FAFC',
  controlUnder: '#DDE4E9',

  accent: '#08BEE5',
  accentStart: '#32fff5',
  accentEnd: '#08BEE5',
  accentContent: '#FFFFFF',

  floating: '#30404F',
  floatingContent: '#FFFFFF',

  green: '#9BC75A',
  yellow: '#F7D858',
  red: '#F08658',
  blue: '#3E7BF6',
  brown: '#876559',
  purple: '#7C80F2',
}
